<a class="text-reset" style="text-align: right" [routerLink]="" style="cursor:pointer;" data-toggle="collapse" (click)="open( termsmodal )">Anvendelse og rettigheder</a>

<ng-template #termsmodal let-modal>
    <!--
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    -->
    <div class="modal-body">
        <div class="sheet modal-dialog">
            <div class="frame modal-content">

                <!-- HERO -->
                <div class="hero">
                    <div class="doc-number">Licensering af &#64;sisufoto billeder</div>
                </div>

                <!-- §1 HVAD ER LICENSEN -->
                <section class="clause">
                    <div class="clause-head">
                        <h2>Hvad er <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/deed.en" target="_blank" rel="noopener">CC BY&#8209;NC&#8209;SA 4.0?</a></h2>
                    </div>
                    <p>CC BY-NC-SA 4.0 giver enhver ret til at bruge, dele og bygge videre på et værk — under forudsætning af,
                        at tre betingelser overholdes. Licensen bruges ofte til billeder, tekster, musik, undervisningsmateriale
                        og andet indhold, hvor ophavspersonen gerne vil dele frit, men samtidig bevare kontrol over kommerciel
                        udnyttelse.</p>
                    <p class="muted">Licensen er juridisk bindende og gælder internationalt. Den kræver ikke registrering — den
                        er automatisk gyldig, så snart værket er offentliggjort med licensangivelsen.</p>

                    <div class="grid3">
                        <div class="letter-card">
                            <span class="letter-glyph">BY</span>
                            <h3>Kreditering</h3>
                            <p>Du skal kreditere ophavspersonen (mindst "&#64;sisufoto" men gerne "&#64;sisufoto - Anders Rostgaard Bystrup"),
                                angive et <a href="https://sisufoto.dk">licenslink</a> og oplyse, hvis der er foretaget ændringer.</p>
                        </div>
                        <div class="letter-card">
                            <span class="letter-glyph">NC</span>
                            <h3>Ikke Kommerciel</h3>
                            <p>Billeder <strong>må ikke</strong> bruges til kommercielle formål eller primær økonomisk vinding uden aftale.</p>
                        </div>
                        <div class="letter-card">
                            <span class="letter-glyph">SA</span>
                            <h3>Del På Samme Vilkår</h3>
                            <p>Bearbejdede eller afledte værker skal deles under samme vilkår og licens,
                                <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/deed.en">CC BY-NC-SA 4.0.</a></p>
                        </div>
                    </div>
                </section>

                <!-- §2 HVAD MÅ MAN -->
                <section class="clause">
                    <div class="clause-head">
                        <h2>Hvad må man — og hvad kræver tilladelse?</h2>
                    </div>

                    <div class="status-row">
                        <span class="status-icon ok">✓</span>
                        <p><strong>Dele</strong> — kopiere og videredistribuere værket i alle medier og formater, uden ændringer.</p>
                    </div>
                    <div class="status-row">
                        <span class="status-icon ok">✓</span>
                        <p><strong>Bearbejde</strong> — remixe, ændre og bygge videre på materialet til ikke-kommercielle formål, så længe det bearbejdede værk deles under samme licens.</p>
                    </div>
                    <div class="status-row">
                        <span class="status-icon ok">✓</span>
                        <p><strong>Bruge til undervisning, forskning og privat brug</strong> — uden forudgående tilladelse, blot med korrekt kreditering.</p>
                    </div>
                    <div class="status-row">
                        <span class="status-icon no">✕</span>
                        <p><strong>Sælge, reklamere med eller på anden måde udnytte værket kommercielt</strong> — det kræver en separat aftale med ophavspersonen (se §3 nedenfor).</p>
                    </div>
                    <div class="status-row">
                        <span class="status-icon no">✕</span>
                        <p><strong>Tilføje yderligere restriktioner</strong> (fx DRM eller striktere licensvilkår), som forhindrer andre i det, licensen ellers tillader.</p>
                    </div>
                </section>

                <!-- §3 KOMMERCIEL BRUG -->
                <section class="clause commercial">
                    <div class="clause-head">
                        <h2>Kommercielt brug</h2>
                    </div>

                    <p>"NC" i licensen betyder, at billeder <strong>ikke må bruges kommercielt</strong> uden udtrykkelig, skriftlig tilladelse.
                        Kommerciel brug dækker blandt andet brug i markedsføring, produkter til salg, sponsoreret indhold,
                        virksomhedskommunikation eller anden brug, hvor formålet primært er økonomisk vinding.</p>
                    <p>Ønsker du at bruge billeder kommercielt, skal du <strong>kontakte <a href="mailto:anders@sisufoto.dk">anders&#64;sisufoto.dk</a>
                        forud for brug</strong> og indgå en aftale. Afhængigt af, hvor og hvor meget billeder skal bruges, aftales
                        en passende <strong>betaling</strong> for brugsretten. Pris fastsættes altid konkret og skriftligt.</p>
                    <p>Det er <strong>dyrt</strong> at være ligeglad med ophavsret!</p>

                    <!--
                    <table class="price-table">
                        <caption>Vejledende prisstruktur for kommerciel brugsret (DKK)</caption>
                        <thead>
                        <tr>
                            <th>Brugskategori</th>
                            <th>Eksempler</th>
                            <th>Pris</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="tier-name">Lille / lokal brug</td>
                            <td>Enkeltmandsvirksomhed, lokalt event, oplag/rækkevidde under ca. 5.000</td>
                            <td class="amount">500–1.500 kr.</td>
                        </tr>
                        <tr>
                            <td class="tier-name">Mellemstor brug</td>
                            <td>SMV-markedsføring, sociale medier-kampagne, tryksager, rækkevidde ca. 5.000–50.000</td>
                            <td class="amount">1.500–5.000 kr.</td>
                        </tr>
                        <tr>
                            <td class="tier-name">Stor / national brug</td>
                            <td>Landsdækkende kampagne, produktemballage, større oplag, rækkevidde over 50.000</td>
                            <td class="amount">5.000–15.000 kr.</td>
                        </tr>
                        <tr>
                            <td class="tier-name">Løbende / redaktionel brug</td>
                            <td>Fast anvendelse over tid, fx på webshop, i abonnement eller tilbagevendende materiale</td>
                            <td class="amount">Årlig licens, forhandles</td>
                        </tr>
                        <tr>
                            <td class="tier-name">Erhvervsmæssig storskala</td>
                            <td>Store virksomheder, internationale kampagner, eksklusiv brugsret</td>
                            <td class="amount">Kontakt for tilbud</td>
                        </tr>
                        </tbody>
                    </table>

                    <div class="note-box">
                        Priserne er retningsgivende og kan justeres efter faktorer som eksklusivitet, brugsperiode, geografisk
                        udbredelse og om værket ændres. Ved tvivl om, hvorvidt en anvendelse er kommerciel, anbefales det altid
                        at spørge ophavspersonen forud for brug.
                    </div>
                    -->
                </section>

                <footer>
                    <p class="muted">Denne side er en forenklet, dansksproget forklaring og erstatter ikke den officielle licenstekst.
                        Læs de fulde og juridisk gældende vilkår hos <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/deed.en" target="_blank" rel="noopener">Creative Commons</a>.</p>
                </footer>

            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Luk</button>
    </div>
</ng-template>


<!--
<ng-template #termsmodal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Terms of Use</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">

        <p>
            Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam.
            Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
        </p>
        <p>
            Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet
            rutrum faucibus dolor auctor.
        </p>
        <p>
            Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.
            Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
    </div>
</ng-template>
-->
